import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Course } from '../../../models/course.model';
import { user } from '../../../models/user.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-course-detail-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './course-detail-dialog.component.html',
  styleUrl: './course-detail-dialog.component.scss',
})
export class CourseDetailDialogComponent implements OnInit {
  course!: Course;


  config = inject(DynamicDialogConfig);
  ref = inject(DynamicDialogRef);

  ngOnInit(): void {
    this.course = this.config.data.course;
  }

  getTeilnehmer(): user[] {
    if (!this.course?.users) return [];
    return this.course.users.filter((u) => !u.isLead);
  }

  close(): void {
    this.ref.close();
  }

  
}
